module.exports = __webpack_public_path__ + "static/vanbex2-06d8afa3b7385f06ec36de2ad232d378.png";